import React from 'react';
import { useTranslation } from 'react-i18next';

// 2kratings-style badge card: tier-colored hexagon + badge name + tier label,
// so the tier is readable at a glance instead of only through a pill color.

export const BADGE_TIER_RANK = { legendary: 0, hof: 1, gold: 2, silver: 3, bronze: 4 };

// Hexagon fill per tier (same hue family as the old pill styles, but solid so
// it stays legible on both the light and the dark background).
const HEX_FILL = {
  legendary: '#C026D3',
  hof: '#7C3AED',
  gold: '#D4A017',
  silver: '#9AA3AB',
  bronze: '#A1673B',
};

const HEX_POINTS = '2,12 7,3.5 17,3.5 22,12 17,20.5 7,20.5';

const prettyTier = (tier) => (tier ? tier.charAt(0).toUpperCase() + tier.slice(1) : '');

export const BadgeHex = ({ tier, className = 'w-5 h-5' }) => (
  <svg viewBox="0 0 24 24" className={`${className} shrink-0`} aria-hidden="true">
    <polygon points={HEX_POINTS} fill={HEX_FILL[tier] || HEX_FILL.bronze} />
  </svg>
);

const BadgeCard = ({ name, tier, category }) => {
  const { t } = useTranslation();
  const tierLabel = t(`compare.tiers.${tier}`, { defaultValue: prettyTier(tier) });

  return (
    <div
      className="flex items-center gap-2.5 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 px-3 py-2"
      title={category ? `${tierLabel} · ${category}` : tierLabel}
    >
      <BadgeHex tier={tier} />
      <div className="min-w-0">
        <div className="text-sm font-semibold text-gray-900 dark:text-gray-100 truncate">{name}</div>
        <div className="text-xs text-gray-500 dark:text-gray-400">{tierLabel}</div>
      </div>
    </div>
  );
};

export default BadgeCard;
